import React, { useState } from "react";
import Slider from "react-slick";
import { useLazyQuery } from "@apollo/client";
import classes from "./youMayAlsoLike.module.css";
import { useAddToCartButton } from "../../../Pregrine/CartPage/useAddToCartButton";
import PinCodeCheck from "../../../components/PinCodeCheck/PinCodeCheck";
import DEFAULT_OPERATIONS from "../../../Pregrine/PinCode/PinCode.gql";
import { useYouMayAlsoLike } from "../../../Pregrine/CartPage/YouMayAlsoLike/useYouMayAlsoLike";
import { useToasts } from "react-toast-notifications";
import YouMayAlsoLikeItem from "../../../components/CartPage/YouMayAlsoLikeItem";
import CompareWidget from "../../../components/CompareWidget/CompareWidget";

const YouMayAlsoLike = (props) => {
  const { cartItems } = props;
  const { addToast } = useToasts();
  const [selectedItem, setSelectedItem] = useState("");
  const [openPinCodeModal, setOpenPinCodeModal] = useState(false);
  const [buyNow, setBuyNow] = useState(false);
  const { checkPinCodeQuery } = DEFAULT_OPERATIONS;
  const talonProps = useYouMayAlsoLike({ cartItems });
  const { youMayALsoLikeProducts } = talonProps;

  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: youMayALsoLikeProducts && youMayALsoLikeProducts.length > 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: youMayALsoLikeProducts && youMayALsoLikeProducts.length > 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: youMayALsoLikeProducts && youMayALsoLikeProducts.length > 2,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 449,
        settings: {
          infinite: youMayALsoLikeProducts && youMayALsoLikeProducts.length > 1,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const cartButtonProps = useAddToCartButton({
    item: selectedItem,
    buyNow,
  });

  const { handleAddToCart } = cartButtonProps;
  const [checkPinCode] = useLazyQuery(checkPinCodeQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.pin_code?.status === "1") {
        handleAddToCart();
      } else {
        addToast(
          "Delivery not available to this location. Please check for other options.",
          {
            appearance: "warning",
            autoDismiss: true,
            style: {
              backgroundColor: "#745600",
              color: "#fff",
            },
          }
        );
      }
    },
  });

  const handleCart = (sku) => {
    const pincode = localStorage.getItem("PinCode");
    if (pincode) {
      checkPinCode({
        variables: {
          pinCode: pincode,
          sku,
          state: Math.random(),
        },
      });
    } else {
      setOpenPinCodeModal(!openPinCodeModal);
    }
  };

  const pinCodeCheckFun = (availableFlag) => {
    if (availableFlag) {
      handleAddToCart();
      setOpenPinCodeModal(false);
    }
  };

  const handlePinCodeModal = () => {
    setOpenPinCodeModal(false);
  };

  return (
    <>
      {youMayALsoLikeProducts && youMayALsoLikeProducts.length ? (
        <section>
          <div className="container you_may_also_like ">
            <div className="row d-flex">
              <div className={`${classes.title} text-center col-12 pb-2`}>
                You May Also Like
              </div>
            </div>
            <Slider {...settings}>
              {youMayALsoLikeProducts.slice(0).map((element, index) => (
                <YouMayAlsoLikeItem
                  key={index}
                  item={element}
                  handleCart={handleCart}
                  setSelectedItem={setSelectedItem}
                  setBuyNow={setBuyNow}
                />
              ))}
            </Slider>
          </div>
        </section>
      ) : null}
      <PinCodeCheck
        openPinCodeModal={openPinCodeModal}
        pinCodeCheckFun={pinCodeCheckFun}
        handlePinCodeModal={handlePinCodeModal}
        product={selectedItem}
      />
      <CompareWidget />
    </>
  );
};

export default YouMayAlsoLike;
